/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Same_This_Vole_SewInputs */

const en_same_this_vole_sew = /** @type {(inputs: Same_This_Vole_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit`)
};

/**
* | output |
* | --- |
* | "Limit" |
*
* @param {Same_This_Vole_SewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const same_this_vole_sew = /** @type {((inputs?: Same_This_Vole_SewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Same_This_Vole_SewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_same_this_vole_sew(inputs)
});